import isMobile from 'ismobilejs';

import {
    ROOM_CLIENT_UPDATE,
    ROOM_CLIENT_LOGIN,
    ROOM_CLIENT_LOGOUT,
    ROOM_CLIENT_LIST
} from '../constants/users';

import {
    VIDEO_OPEN_USER_VIDEO,
    VIDEO_WINDOW_OPEN,
    VIDEO_WINDOW_CLOSE,
    VIEW_USER_REQUEST,
    VIEW_USER_STOP,
    VIEW_USER_SUCCESS,

    STREAM_LIMIT_TABLET
} from '../constants/streaming';

import appConfig from '../../app.config';
let {WINDOW_AUTOCLOSE_INTERVAL} = appConfig;

import Registry from '../registry/index';
import {LOGIN_SUCCESS, CLOSE} from "../constants/general";

const streamingMiddleware = (store) => (next) => (action) => {
    if (action.type === VIDEO_OPEN_USER_VIDEO) {
        let {users} = store.getState();
        //console.log(users);
        let streamer = users.get({ufrag:action.ufrag});
        if (streamer) {
            //console.log(streamer);
            if (isMobile.any) {
                let stream_id = Object.keys(streamer.streams)[0];
                store.dispatch({type: VIDEO_WINDOW_OPEN, streamer: streamer, stream_id: stream_id});
            } else {

                for (let stream_id in streamer.streams) {
                    store.dispatch({type: VIDEO_WINDOW_OPEN, streamer: streamer, stream_id: stream_id});
                }
            }
        }
        next(action);
        return;
    }

    if (action.type === VIDEO_WINDOW_OPEN) {
        //console.log("VIDEO_WINDOW_OPEN");
        // todo: move this check to separate middleware
        // only one video at a time on phones or for Free users
        if (!action.streamer && action.ufrag) {
            let {users} = store.getState();
            let streamer = users.get({ufrag:action.ufrag});
            action.streamer = streamer;
        }
        let {currentUser, browser, videoStreams} = store.getState();

        // video window already opened, skipping
        if (videoStreams[action.stream_id] && videoStreams[action.stream_id].stream) return next(action);

        if ( (!currentUser.isXXL() && !currentUser.isAnonymous()) || browser.phone ) {
            for (let stream_id in videoStreams) {
                if (videoStreams[stream_id].user.uid != action.streamer.uid || browser.phone)
                    store.dispatch({type: VIDEO_WINDOW_CLOSE, stream_id});
            }
        }

        next(action);

        // todo: maybe move dispatching this event to chatInterface-redux binding as aux event handler (pre-hitagi-stream-view?)
        // todo: check if user is actually streaming
        let keysVideoStreams = Object.keys(videoStreams);
        let conditionMaxVideoStreams = keysVideoStreams.length < STREAM_LIMIT_TABLET;
        let lastVideoStream = videoStreams[keysVideoStreams[keysVideoStreams.length - 1]];

        if (browser.tablet && !conditionMaxVideoStreams) store.dispatch({type: VIDEO_WINDOW_CLOSE, stream_id: lastVideoStream.stream_id});

        store.dispatch({type: VIEW_USER_REQUEST, streamer: action.streamer, stream_id: action.stream_id});

        return;
    }

    // the most important part - chatInterface API binding
    if (action.type === VIEW_USER_REQUEST) {
        let chatInterface = Registry.get('chatInterface');
        chatInterface.sendViewRequest(action.stream_id, action.streamer.ufrag);
        
        //console.log(users);
        
        return next(action);
    }

    if (action.type === VIEW_USER_SUCCESS) {
        let {users} = store.getState();
        let streamer = users.get({ufrag:action.ufrag});
        action.streamer = streamer;

        return next(action);
    }


    // leaving a stream on streamer logout
    if (action.type === VIDEO_WINDOW_CLOSE) {
        let stream_id = action.stream_id,
            videoStreams = store.getState().videoStreams,
            videoStream = videoStreams[stream_id];

        if (videoStream && videoStream.stream) {
            /** @type ChatInterfaceHitagi **/
            let chatInterface = Registry.get('chatInterface');
            chatInterface.viewUserLeaveStream(stream_id);
        }
    }

    // auto-closing offline video windows
    if (action.type === VIEW_USER_STOP) {
        let stream_id = action.stream_id;

        //let ufrag = action.user.ufrag,
        let videoStreams = store.getState().videoStreams;
        let videoStream = videoStreams[stream_id];

        let autoCloseInterval = action.auto_close_interval ? action.auto_close_interval : WINDOW_AUTOCLOSE_INTERVAL;

        if (videoStream && videoStream.timeoutHandle) {
            clearTimeout(videoStream.timeoutHandle);
        }

        if (videoStream) {
            const timeoutHandle = setTimeout(function() { store.dispatch({type: VIDEO_WINDOW_CLOSE, stream_id: stream_id}) }, autoCloseInterval);
            return next({...action, timeoutHandle});
        }
    }

    // stream view auto-restart
    if (action.type === ROOM_CLIENT_UPDATE
        || action.type === ROOM_CLIENT_LOGIN) {

        let videoStreams = store.getState().videoStreams;
        let oldUsers = store.getState().users;
        let oldUser = oldUsers.get({ufrag: action.user.ufrag});
        let oldStreams = {};
        if (oldUser) {
            oldStreams = oldUser.streams;
        }
        next(action);


        // Do we have at least one connected stream of this user?
        let alreadyViewingThisUser = false;
        let disconnectedFromThisUser = false;
        
        for (let stream_id in videoStreams) {
            if (videoStreams[stream_id].user.uid == action.user.uid) {
                alreadyViewingThisUser = true;
                break;
            }
        }

        if (alreadyViewingThisUser) {
            // Connect all new streams
            for (let stream_id in action.user.streams) {
                let videoStream = videoStreams[stream_id];
                if (!oldStreams[stream_id]) {
                    store.dispatch({type: VIDEO_WINDOW_OPEN, stream_id: stream_id, streamer: action.user});
                }

                if ( (videoStream && !videoStream.stream && action.user.streaming)
                    || (videoStream && !videoStream.online)) {
                    store.dispatch({type: VIDEO_WINDOW_OPEN, stream_id: stream_id, streamer: action.user});

                    if (videoStream.timeoutHandle) clearTimeout(videoStream.timeoutHandle);
                }
            }
        }
        return;
    }

    if (action.type === ROOM_CLIENT_LIST) {
        for (let index in action.list) {
            let user = action.list[index];

            let videoStreams = store.getState().videoStreams,
                videoStream = videoStreams[user.ufrag];
            if (videoStream && !videoStream.stream && user.streaming) {
                store.dispatch({type: VIEW_USER_REQUEST, ufrag: user.ufrag});

                if (videoStream.timeoutHandle) clearTimeout(videoStream.timeoutHandle);
            }

        }
    }

    if (action.type === LOGIN_SUCCESS) {
        next(action);
        //console.log("LOGIN_SUCCESS");

        // reopen closed videos
        let videoStreams = store.getState().videoStreams;
        for (let streamId in videoStreams) {
            store.dispatch({type: VIEW_USER_STOP, stream_id: streamId, auto_close_interval: WINDOW_AUTOCLOSE_INTERVAL * 3});
        }
        

        let ufrag = Registry.get('chatInterface')._loginData.ufrag;

        window.setTimeout(function() {
            if (ufrag) {
                store.dispatch({type: VIDEO_OPEN_USER_VIDEO, ufrag: ufrag});
            }
        }, 1000);



        return;
    }

    if (action.type === CLOSE) {
        let videoStreams = store.getState().videoStreams;
        for (let streamId in videoStreams) {
            store.dispatch({type: VIEW_USER_STOP, stream_id: streamId, auto_close_interval: WINDOW_AUTOCLOSE_INTERVAL * 60});
        }

        //return;
    }
    

    next(action);
};

export default streamingMiddleware;


// WEBPACK FOOTER //
// ./src/middleware/streaming.js